(function () {
	'use strict';

	angular
		.module('franchiser.components')
		.controller('CompanyListFranchiserController', CompanyListFranchiserController)

	/** @ngInject */
	function CompanyListFranchiserController($q, $httpParamSerializer, CompanyService, RegionalService, ClusterService,
		LoadingHelper, UtilHelper, AuthenticationService, CompanyStatusService, CompanyEconomicGroupService, SYSTEM_MODULES, ROUTES, MeService) {
		const vm = this;

		let isTableSearch = false;
		let forcePaginationReset = false;
		let hasModifiedSearchStatus = false;

		vm.isSearchDisabled = () => {
			if (vm.selectedCluster || vm.selectedRegional || vm.selectedEconomicGroup || vm.selectedStatus || hasModifiedSearchStatus || (vm.selectedSearchField && vm.searchText))
				return false;

			return true;
		}

		vm.isClearDisabled = () => {
			if (isTableSearch)
				return false;

			if (vm.selectedCluster || vm.selectedRegional || vm.selectedEconomicGroup || vm.selectedStatus || hasModifiedSearchStatus || vm.selectedSearchField || vm.searchText)
				return false;

			return true;
		}

		vm.changeCompanyStatus = status => {
			if (vm.selectedStatus && vm.selectedStatus.Id == 6) return;

			vm.searchStatus = status;
			hasModifiedSearchStatus = true;
		}

		vm.doSearch = (event, isFromButton) => {
			if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
				forcePaginationReset = true;

				vm.tableCallServer();
			}
		}

		vm.clearSearch = () => {
			vm.selectedCluster = null;
			vm.selectedRegional = null;
			vm.selectedStatus;
			vm.selectedEconomicGroup = null;
			vm.selectedSearchField = null;
			vm.searchText = null;
			vm.searchStatus = 1;
			hasModifiedSearchStatus = false;

			if (isTableSearch)
				vm.tableCallServer();

			isTableSearch = false;
		}

		vm.tableCallServer = (tableState, stCtrl) => {
			if (!vm.stCtrl && stCtrl)
				vm.stCtrl = stCtrl;

			if (!tableState && vm.stCtrl) {
				vm.stCtrl.pipe();
				return;
			}

			vm.isLoading = true;

			if (forcePaginationReset) {
				tableState.pagination.start = 0;
				forcePaginationReset = false;
			}

			const pagination = tableState.pagination;
			const start = pagination.start || 0;
			const number = pagination.number || 10;

			getCompanies(start, number, tableState);
		}

		vm.configureReportDownload = () => {
			LoadingHelper.startLoading('.btn-download', true);
			vm.isLoadingDownloadData = true;

			const parameters = prepareParameters(0, 0, null);

			MeService
				.getDownloadToken()
				.then(success => {
					vm.isLoadingDownloadData = false;
					LoadingHelper.stopLoading('.btn-download', true);

					window.open(`${ROUTES.API}/company-report?Token=${success}&${$httpParamSerializer(parameters)}`, '_blank');
				}, error => {
					vm.isLoadingDownloadData = false;
					LoadingHelper.stopLoading('.btn-download', true);
					UtilHelper.errorCallback(error);
				})
		}

		init();

		function getCompanies(skip, perPage, tableState) {
			let parameters = prepareParameters(skip, perPage, tableState);

			CompanyService
				.getByParameters(parameters)
				.then(success => {
					vm.companies = success.Registers;
					tableState.pagination.numberOfPages = success.NumberOfPages;

					vm.isLoading = false;
				}, error => {
					vm.companies = null;
					vm.isLoading = false;
					UtilHelper.errorCallback(error);
				})
		}

		function getRegionals() {
			RegionalService
				.getAll()
				.then(success => {
					vm.regionals = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.custom-filters');
				})
		}

		function getClusters() {
			return ClusterService
				.getAll()
				.then(success => {
					vm.clusters = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.custom-filters');
				})
		}

		function getStatus() {
			return CompanyStatusService
				.getAll()
				.then(success => {
					vm.status = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.custom-filters');
				})
		}

		function getEconomicGroups() {
			return CompanyEconomicGroupService
				.getAll()
				.then(success => {
					vm.economicGroups = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.custom-filters');
				})
		}

		function prepareParameters(skip, perPage, tableState) {
			let params = {
				Skip: skip,
				PerPage: perPage,
				OrderBy: 'FantasyName',
				OrderDescending: false
			}

			if (vm.selectedCluster || vm.selectedRegional || vm.selectedEconomicGroup || vm.selectedStatus || vm.searchStatus > 0 || (vm.selectedSearchField && vm.searchText))
				isTableSearch = true;

			if (vm.searchStatus > 0)
				params.Active = vm.searchStatus == 1;

			if (vm.selectedCluster)
				params.ClusterId = vm.selectedCluster.Id;

			if (vm.selectedRegional)
				params.RegionalId = vm.selectedRegional.Id;

			if (vm.selectedEconomicGroup)
				params.EconomicGroupId = vm.selectedEconomicGroup.Id;

			if (vm.selectedStatus)
				params.StatusId = vm.selectedStatus.Id;

			if (vm.selectedStatus && vm.selectedStatus.Id == 6) {
				vm.searchStatus = null;
				params.Closed = true;
				params.Active = false;
			}

			if (tableState && tableState.sort.predicate) {
				params.OrderBy = tableState.sort.predicate;
				params.OrderDescending = tableState.sort.reverse;
			}

			if (vm.selectedSearchField && vm.searchText) {
				params.SearchField = vm.selectedSearchField.Value;
				params.SearchQuery = vm.searchText;
			}

			return params;
		}

		function init() {
			const loggedUserData = AuthenticationService.getUser();

			vm.canUserHandlePerson = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
			vm.selectedRegional;
			vm.selectedStatus;
			vm.selectedCluster;
			vm.selectedEconomicGroup;
			vm.selectedSearchField;
			vm.searchText;
			vm.isLoading = true;
			vm.searchStatus = 1;

			vm.searchFields = [{
				Value: 'Id',
				Description: 'Id'
			}, {
				Value: 'Document',
				Description: 'CNPJ'
			}, {
				Value: 'CorporateName',
				Description: 'Razão Social'
			}, {
				Value: 'FantasyName',
				Description: 'Nome Fantasia'
			}, {
				Value: 'ExternalCode',
				Description: 'Código Empresa'
			}, {
				Value: 'UniqueCode',
				Description: 'Código Único'
			}];

			LoadingHelper.startLoading('.custom-filters');

			$q.all([getRegionals(), getClusters(), getEconomicGroups(), getStatus()])
				.then(() => {
					LoadingHelper.stopLoading('.custom-filters');
				})
		}
	}
}());